import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';

@Component({
  standalone: false,
  selector: 'app-edit-subadmin',
  templateUrl: './edit-subadmin.component.html'
})
export class EditSubadminComponent implements OnInit {

  addSubAdminForm: FormGroup | any;
  file: any;
  imageType: any;
  imageUrl: any;
  countryArr: any = [];
  myPermission: any = []
  subAdminList: any;
  userId: any;
  permission: any;
  permissionId: any;

  constructor(private mainService: MainService, private router: Router,
    private activatedroute: ActivatedRoute) {
    this.activatedroute.params.subscribe(res => {
      this.userId = res.id
    })
  }

  ngOnInit() {
    this.addSubAdminFormValidation();
    this.getCountryCodeData();
    this.getSubAdminList();
  }

  // Add Subadmin Form Validation

  addSubAdminFormValidation() {
    this.addSubAdminForm = new FormGroup({
      'firstName': new FormControl('', Validators.compose([Validators.required, Validators.maxLength(62), Validators.pattern(/^[^\s][a-zA-Z ]*$/)])),
      'lastName': new FormControl(''),
      'phoneCode': new FormControl('+1'),
      "email": new FormControl('', ([Validators.required, Validators.pattern(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/i), Validators.maxLength(50)])),
      "phoneNumber": new FormControl('', ([Validators.required, Validators.pattern(/^[1-9][0-9]{9,13}$/)])),
      "password": new FormControl('', Validators.compose([Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/)])),
      "confirmPassword": new FormControl('', Validators.compose([Validators.required, Validators.minLength(8)])),
      'dashboard': new FormControl(false),
      'patientManagement': new FormControl(false),
      'therapistManagement': new FormControl(false),
      'programManagement': new FormControl(false),
      'subadminManagement': new FormControl(false),
      'transactionManagement': new FormControl(false),
      'assessment': new FormControl(false),
      'staticContentManagement': new FormControl(false),
      'notificationManagement': new FormControl(false),
      'libraryManagement': new FormControl(false),
      'reviewManagement': new FormControl(false),
      'chatManagement': new FormControl(false),
      'journalManagement': new FormControl(false),
      'faqManagement': new FormControl(false),
      'queryManagement': new FormControl(false),
      'programTypeManagement': new FormControl(false)
    })
  }

  getCountryCodeData() {
    this.mainService.getCountryCode().subscribe((res) => {
      this.countryArr = res
    })
  }

  ValidateFileUpload(event: any) {
    this.file = event.target.files;
    if (this.file[0]) {
      this.imageType = this.file[0].type;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imageUrl = e.target.result;
        this.uploadImage()
      };
      reader.readAsDataURL(this.file[0]);
    }
  }

  // upload Image api integration 
  uploadImage() {
    const data: FormData = new FormData();
    data.append('image', this.file[0])
    this.mainService.postApi(ApiUrls.uploadImage, data, 3).subscribe((res) => {
      if (res.responseCode == 200) {
        this.imageUrl = res.result.image
      }
    })
  }

  // getSubAdminList api integration 
  getSubAdminList() {

    this.mainService.showSpinner();
    this.mainService.getApi(ApiUrls.viewSubadmin + `?userId=${this.userId}`, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.subAdminList = res.result;
        this.imageUrl = this.subAdminList.profilePic
        this.permission = res['result']['permissions'][0];
        this.permissionId = res['result']['permissions'][0]._id
        this.addSubAdminForm.patchValue({
          firstName: this.subAdminList.firstName,
          lastName: this.subAdminList.lastName,
          email: this.subAdminList.email,
          phoneNumber: this.subAdminList.mobileNumber,
          phoneCode: this.subAdminList.countryCode,
          assesmentManagement: this.permission.assesmentManagement,
          chatManagement: this.permission.chatManagement,
          staticContentManagement: this.permission.contentManagement,
          dashboard: this.permission.dashboard,
          faqManagement: this.permission.faqManagement,
          journalManagement: this.permission.journalManagement,
          libraryManagement: this.permission.libraryManagement,
          notificationManagement: this.permission.notificationManagement,
          programManagement: this.permission.programManagement,
          subadminManagement: this.permission.subadminManagement,
          therapistManagement: this.permission.therapistManagement,
          transactionManagement: this.permission.transactionManagement,
          patientManagement: this.permission.patientManagement,
          queryManagement: this.permission.queryManagement,
          programTypeManagement: this.permission.programTypeManagement,
          reviewManagement: this.permission.reviewManagement
        })

        this.mainService.hideSpinner();
      } else {
        this.mainService.hideSpinner();
        this.mainService.errorToast(res.responseMessage)
      }
    })
  }


  // edit subadmin api integration 

  editSubadminApi() {
    const data = {
      'firstName': this.addSubAdminForm.value.firstName,
      'lastName': this.addSubAdminForm.value.lastName,
      'email': this.addSubAdminForm.value.email,
      'countryCode': this.addSubAdminForm.value.phoneCode,
      'mobileNumber': this.addSubAdminForm.value.phoneNumber,
      'profilePic': this.imageUrl,
      // 'password' : this.addSubAdminForm.value.password,
      'dashboard': this.addSubAdminForm.value.dashboard,
      'patientManagement': this.addSubAdminForm.value.patientManagement,
      'therapistManagement': this.addSubAdminForm.value.therapistManagement,
      'programManagement': this.addSubAdminForm.value.programManagement,
      'subadminManagement': this.addSubAdminForm.value.subadminManagement,
      'transactionManagement': this.addSubAdminForm.value.transactionManagement,
      'assesmentManagement': this.addSubAdminForm.value.assesmentManagement,
      'contentManagement': this.addSubAdminForm.value.staticContentManagement,
      'notificationManagement': this.addSubAdminForm.value.notificationManagement,
      'libraryManagement': this.addSubAdminForm.value.libraryManagement,
      'reviewManagement': this.addSubAdminForm.value.reviewManagement,
      'chatManagement': this.addSubAdminForm.value.chatManagement,
      'journalManagement': this.addSubAdminForm.value.journalManagement,
      'faqManagement': this.addSubAdminForm.value.faqManagement,
      'queryManagement': this.addSubAdminForm.value.queryManagement,
      'programTypeManagement': this.addSubAdminForm.value.programTypeManagement
    }
    this.mainService.putApi(ApiUrls.editSubadmin + `?userId=${this.userId}`, data, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.router.navigate(['subadmin-mgt']);
        this.mainService.successToast(res.responseMessage)
      }
      else {
        this.mainService.errorToast(res.responseMessage)
      }
    })
  }



  // Block special character from name
  inputkeyPress(e: any) {
    var k
    if (e.charCode == 32 && !e.target.value) {
      e.preventDefault()
    }
    else {
      document.all ? k = e.keyCode : k = e.which;
      return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32);
    }
  }
  //Allow only numbers
  inputKeyPress(e: any) {
    var k
    if (e.charCode == 32 && !e.target.value) {
      e.preventDefault()
    }
    else {
      document.all ? k = e.keyCode : k = e.which;
      return ((k > 47 && k < 58) || k == 8);
    }
  }

  //For password keypres
  passwordKeyPress(e: any) {
    if (e.charCode == 32 && !e.target.value) {
      e.preventDefault()
    }
  }

  onImageError(event: any) {
    event.target.src = 'https://res.cloudinary.com/smsit/image/upload/v1597335652/fmcvdi2g6ogd5vwzvzfa.jpg';
  }

}
